<template>
    <div class="row">
        <div class="col-12 drag-drop-area drag-drop-area-colors my-2 upload" v-if="mode ==='drag-drop'">
            <div :class="`upload_${id}`" :id="`upload_${id}`">
                <div class="text-center p-3">
                    <h5 class="black-text-color"><i class="fa fa-file-upload"></i> <span v-html="lang('drop_files_or_upload')"></span></h5>
                    <file-upload
                            class="btn btn-primary"
                            :post-action="postAction"
                            :multiple="false"
                            :input-id="`upload_area_${id}`"
                            :drop="`.upload_${id}`"
                            @input-filter="inputFilter"
                            @update:model-value="updateValue"
                            :drop-directory="true"
                            v-model="files"
                            v-bind="$attrs">
                        {{lang('select_files_browse')}}
                    </file-upload>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VueUploadComponent from 'vue-upload-component';

    export default {
        name: "np-upload",
        components: {
            'file-upload': VueUploadComponent,
        },
        props: {
            mode: {
                type: String,
                default: 'single' //drag-drop, single, multi,
            },
            id: {
                type: String,
                default: ''
            },
            postAction: {
                type: String,
                default: ''
            },
            value: {
                type: Array,
                default: () => []
            },
            modelValue: {
                type: Array,
                default: () => []
            },
            successCallback: {
                type: Function
            },
            errorCallback: {
                type: Function
            },
            data: {
                type: Object,
                default: () => {}
            },
            maxSize: {
                type: Number, //in megabytes
                default: () => {
                    return 10
                }
            }
        },
        data() {
            return {
                files: [],
                uploading: false
            }
        },
        created() {
            this.files = this.modelValue;
        },
        computed: {},
        methods: {
            updateValue: function (value) {
                this.$emit('update:modelValue', value)
                this.$emit('input', value)
            },
            handleSuccess: function(data) {
                if(!!this.successCallback) {
                    this.successCallback(data);
                }
            },
            handleError: function(data) {
                if(!!this.errorCallback) {
                    this.errorCallback(data);
                }
            },
            doFileUpload: function (newFile, oldFile, prevent) {
                // Allowed file types using file extensions
                if (!/\.(jpeg|jpg|png|pdf|tiff)$/i.test(newFile.name)) {
                    newFile.error = newFile.name + " : " + LANGUAGE['file_upload_failed'] + "-" + LANGUAGE['invalid_file_type'];
                    this.handleError(newFile);
                    return prevent()
                }

                // Allowed file size
                if (newFile.size > (this.maxSize * 1000000)) {
                    newFile.error = newFile.name + " : " + LANGUAGE['file_upload_failed'] + "-" +   LANGUAGE['invalid_file_size'];
                    this.handleError(newFile);
                    return prevent();
                }

                let formData = new FormData();
                formData.append('file', newFile.file, newFile.name);

                // do file upload
                let $this = this;
                this.uploading = true;
                this.getAxiosInstance().post(this.postAction, formData)
                    .then(response => {
                        const data = response.data;
                        $this.uploading = false;
                        if (data.result === 'SUCCESS') {
                            newFile.success = true;
                            newFile.file_name = data['file_name'];
                            newFile.name = newFile.name.replace(/[_-]/g, " ");
                            this.$emit('update:modelValue', [newFile])
                            this.$emit('input', [newFile])
                        } else if (data.result === 'ERROR') {
                            // newFile.error = newFile.name + " : " + ['file_upload_failed'] + "-" +  (data.error.explanation || data.error);
                            // $this.handleError(newFile);
                        }
                    })
                    .catch(error => {
                        $this.uploading = false;
                        objCommon.generalPreloader.hide_pl($('.main_contentContainer'));
                        if (error.responseJSON && error.responseJSON.errorMessage) {
                            newFile.error = newFile.name + " : " + LANGUAGE['file_upload_failed'] + "-" +  (error.responseJSON.errorMessage || '');
                        } else {
                            newFile.error = newFile.name + " : " + LANGUAGE['file_upload_failed'] + "-" +  LANGUAGE['connection_error_has_occured'];
                        }
                        $this.handleError(newFile);
                    })

                // $.ajax({
                //         url: this.postAction,
                //         type: 'POST',
                //         data: formData,
                //         dataType: 'json',
                //         cache: false,
                //         processData: false,
                //         contentType: false,
                //         timeout: 300000,
                //         success: function (data) {
                //             $this.uploading = false;
                //             if (data.result === 'SUCCESS') {
                //                 newFile.success = true;
                //                 newFile.file_name = data['file_name'];
                //                 newFile.name = newFile.name.replace(/[_-]/g, " ");
                //             } else if (data.result === 'ERROR') {
                //                 newFile.error = newFile.name + " : " + ['file_upload_failed'] + "-" +  (data.error.explanation || data.error);
                //                 $this.handleError(newFile);
                //             }
                //         },
                //         error: function (data) {
                //             $this.uploading = false;
                //             objCommon.generalPreloader.hide_pl($('.main_contentContainer'));
                //             if (data.responseJSON && data.responseJSON.errorMessage) {
                //                 newFile.error = newFile.name + " : " + LANGUAGE['file_upload_failed'] + "-" +  (data.responseJSON.errorMessage || '');
                //             } else {
                //                 newFile.error = newFile.name + " : " + LANGUAGE['file_upload_failed'] + "-" +  LANGUAGE['connection_error_has_occured'];
                //             }
                //             $this.handleError(newFile);
                //         }
                //     }
                // );
            },
            inputFilter: function (newFile, oldFile, prevent) {
                if (newFile && !oldFile) { // Add file
                    this.doFileUpload(newFile, oldFile, prevent)
                }

                if (!newFile && oldFile) {
                    // Remove file

                    // Automatically delete files on the server
                    if (oldFile.success && oldFile.response.id) {
                        // $.ajax({
                        //   type: 'DELETE',
                        //   url: '/file/delete?id=' + oldFile.response.id,
                        // });Sna
                    }
                }
            },
            uploadStatus: function() {
                return this.uploading;
            }
        },
        watch: {
            modelValue: function (val) {
                this.files = val
            }
        }
    }
</script>

<style>
    .drag-drop-area-colors {
        border: 2px #2C7BBC dashed !important;
        background-color: #FFFFFF !important;
    }

    .drag-drop-area.upload label {
        opacity: 0 !important;
    }

    .black-text-color {
        color: #000000 !important;
    }

    .drag-drop-area span.btn.btn-primary {
        background-color: #2C7BBC !important;
    }

    .drag-drop-area h5 span {
        font-size: 1rem !important;
    }
</style>